












































































import ClearanceApprovalCreateRequestDialog from "@/components/clearance-approval/ClearanceApprovalCreateRequestDialog.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { ClearanceApproval, IClearanceApproval } from "@/models/clearance-approval.entity";
import { IClearance } from "@/models/clearance.entity";
import { IReport } from "@/models/report.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { Component, Prop, Vue } from "vue-property-decorator";
import ClearanceApprovalSideCard from "../clearance-approval/ClearanceApprovalSideCard.vue";
import RefsClearanceApproval from "../utility/RefsClearanceApproval.vue";
import RefsSelected from "../utility/RefsSelected.vue";

@Component({
  components: {
    RefsSelected,
    RefsClearanceApproval,
    ClearanceApprovalCreateRequestDialog,
    ClearanceApprovalSideCard
  }
})
export default class ClearanceDetailClearanceApprovalCard extends Vue {
  readonly ResourceEnum = ResourceEnum;

  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop({ required: true })
  value!: IClearance;

  @Prop()
  report?: IReport;

  clearanceApprovals: IClearanceApproval[] = [];

  isLoading = false;

  selectedClearanceApproval: IClearanceApproval | null = null;

  setSelectedClearanceApproval(value: IClearanceApproval) {
    this.selectedClearanceApproval = null;

    this.$nextTick(() => {
      this.selectedClearanceApproval = value;
    });
  }

  /**
   * Open the create clearance approval request dialog
   */
  openCreateDialog(): void {
    (this.$refs.createDialog as ClearanceApprovalCreateRequestDialog).open();
  }

  async mounted() {
    this.isLoading = true;

    const clearanceApprovalsAsync = this.value.clearanceApprovalIds.map(id =>
      new ClearanceApproval({ id, partnerId: this.value.partnerId }).fetch().catch(e => {
        this.$log.error(e);
        return null;
      })
    );

    const clearances = (await Promise.all(clearanceApprovalsAsync)).filter(c => !!c) as IClearanceApproval[];
    this.clearanceApprovals.splice(0, this.clearanceApprovals.length, ...clearances);

    this.isLoading = false;
  }
}
